import { forwardRef, useMemo } from 'react';

import { Chip as MantineChip, ChipProps as MantineChipProps } from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import { ChipOverrideClassNames } from './Chip.styles';
import { ChipGroup, ChipGroupProps } from './ChipGroup';

interface ChipProps extends MantineChipProps {
  /**
   * Show tick icon on the left side of the chip.
   * By default the component has tick icon, to show or hide
   * we use tick prop.
   */
  tick?: boolean;
}

type ChipComponent = React.ForwardRefExoticComponent<
  ChipProps & React.RefAttributes<HTMLInputElement>
> & {
  Group: typeof ChipGroup;
};

const Chip = forwardRef<HTMLInputElement, ChipProps>(
  (
    {
      size = 'sm',
      radius = 'sm',
      variant = 'filled',
      tick = false,
      color,
      classNames,
      ...rest
    },
    ref
  ) => {
    const classes = useMemo(() => {
      return ChipOverrideClassNames({
        size,
        color,
        tick,
        ...rest
      });
    }, [size, color, tick]);

    const mergedClassNames = useMergeClassNames({
      classNames: [classNames, classes]
    });

    return (
      <MantineChip
        {...rest}
        ref={ref}
        size={size}
        radius={radius}
        color={color}
        variant={variant}
        classNames={mergedClassNames}
      />
    );
  }
) as ChipComponent;

Chip.Group = ChipGroup;

export { Chip, ChipGroup };
export type { ChipProps, ChipGroupProps };
